import { render, staticRenderFns } from "./BetLayout.vue?vue&type=template&id=f951f4f6&scoped=true&"
import script from "./BetLayout.vue?vue&type=script&lang=js&"
export * from "./BetLayout.vue?vue&type=script&lang=js&"
import style0 from "./BetLayout.vue?vue&type=style&index=0&id=f951f4f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f951f4f6",
  null
  
)

export default component.exports